import React from "react";
import Title from "../home/Title";
import Education from "./Education";
import Skills from "./Skills";

const Resume = () => {
  return (
    // Below "lgl" (1024px): Home.js renders "My Resume" and "My Skills" as
    // two separate mobile cards directly (see mobileSections in Home.js) —
    // this component isn't used there. At "lgl" and up: unchanged, both
    // still flow together in one panel here.
    <section id="resume" className="w-full min-w-0">
      <Title title="My" subTitle="Resume" mobileIndent />
      <Education />
      <Title title="My" subTitle="Skills" mobileIndent />
      <Skills />
    </section>
  );
};

export default Resume;
